/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_No_Users_YetInputs */



/**
* | output |
* | --- |
* | "There are no users in the system yet." |
*
* @param {User_List_No_Users_YetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_no_users_yet = /** @type {((inputs?: User_List_No_Users_YetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_No_Users_YetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y a pas encore d'utilisateurs dans le système.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay usuarios en el sistema todavía.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não há usuários no sistema.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non ci sono ancora utenti nel sistema.")
	return /** @type {LocalizedString} */ ("There are no users in the system yet.")
});